<template>
  <div class="card shadow"
       :class="type === 'dark' ? 'bg-default': ''">
    <div class="card-header border-0"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <div class="row align-items-center">
        <div class="col-md-8 mb-1">
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              placeholder="Company Name, Email"
              aria-label="Company Name, Email"
              aria-describedby="Company Name, Email"
              v-model="search_text"
            />
            <div class="input-group-append">
              <button class="btn btn-info" type="button" @click="getEmployers(1)">Search</button>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-1 text-right">
          <base-button type="primary" size="md" @click="openCreateModal()">Create New</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive" style="min-height:300px;">
      <base-table class="table align-items-center table-flush"
                  :class="type === 'dark' ? 'table-dark': ''"
                  :thead-classes="type === 'dark' ? 'thead-dark': 'thead-light'"
                  tbody-classes="list"
                  :data="employers">
        <template slot="columns">
          <th class="text-center">#</th>
          <th class="text-center">Company Name</th>
          <th class="text-center">Email</th>
          <th class="text-center">Contact Person</th>
          <th class="text-center">Contact No.</th>
          <th class="text-center">Applied Date</th>
          <th class="text-center">Status</th>
          <th></th>
        </template>

        <template slot-scope="{row, index}">
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{index+1+(10*(pageNumber-1))}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.company_name}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.email_address}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.contact_person}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.contact_number}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm">{{row.applied_date}}</span>
              </div>
            </div>
          </td>
          <td scope="row" class="text-center">
            <div class="media align-items-center">
              <div class="media-body">
                <span class="name mb-0 text-sm" v-if="row.status == 0">Pending</span>
                <span class="name mb-0 text-sm text-success" v-if="row.status == 1">Approved</span>
                <span class="name mb-0 text-sm text-danger" v-if="row.status == 2">Rejected</span>
              </div>
            </div>
          </td>

          <td class="text-right">
            <base-dropdown class="dropdown"
                           position="right">
              <a slot="title" class="btn btn-sm btn-icon-only text-light" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
              </a>

              <template>
                <a class="dropdown-item" @click="openUpdateModal(row.id)">Update Profile</a>
                <a class="dropdown-item" @click="openUpdateStatusModal(row.id, row.status)">Update Status</a>
                <a class="dropdown-item" @click="openTopUpCreditModal(row.id, row.company_name)">Top Up Credit</a>
              </template>
            </base-dropdown>
          </td>

        </template>

      </base-table>
    </div>

    <div class="row" id="div-edit-employers-profile">
        <div class="col-md-4">
            <modal :show.sync="modals.admin_profile_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg" id="modal-edit-employers-profile" @change="check()">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0" v-if="action == 1">CREATE EMPLOYER</h3>
                                    <h3 class="mb-0" v-if="action == 2">UPDATE PROFILE</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                            <div>
                                <div>
                                  <tabs fill class="flex-column flex-md-row">
                                      <card shadow>
                                          <tab-pane title="Info">
                                              <span slot="title">
                                                  Info
                                              </span>

                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Company Name:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Company Name"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.companyName" />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Reg. No.:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Reg. No."
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.companyReg" />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Industry:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <select class="form-control" v-model="employer.industry">
                                                     <option value=''>-- Select Industry --</option>
                                                     <template v-for="(data, key) in industriesList">
                                                        <option v-bind:key="key" v-bind:value="data.industry_id">{{ data.name }}</option>
                                                    </template>
                                                  </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Person In Charge:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Person In Charge"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.pic"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Contact No.:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Contact No."
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.contactNo"
                                                  />
                                                </div>
                                              </div>
                                              <!-- <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Email Address: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Email Address"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.emailAddress"
                                                  />
                                                </div>
                                              </div> -->
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Website:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Website"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.website"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3">Is Anonymous: </div>
                                                <div class="col-sm-9">
                                                  <base-checkbox class="mb-3" v-model="employer.isAnonymous"></base-checkbox>
                                                </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Additional">
                                              <span slot="title">
                                                  Additional
                                              </span>
                                              
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Dress Code:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <select class="form-control" v-model="employer.dressCode">
                                                     <option value=''>-- Select Dress Code --</option>
                                                     <template v-for="(data, key) in dressCodesList">
                                                        <option v-bind:key="key" v-bind:value="data.dress_code_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Company Size:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <select class="form-control" v-model="employer.companySize">
                                                     <option value=''>-- Select Company Size --</option>
                                                     <template v-for="(data, key) in companySizesList">
                                                        <option v-bind:key="key" v-bind:value="data.company_size_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Working Hours:<span class="text-danger">*</span></div>
                                                <div class="col-sm-4">
                                                    <base-input addon-left-icon="ni ni-time-alarm">
                                                        <flat-picker slot-scope="{focus, blur}"
                                                                     @on-open="focus"
                                                                     @on-close="blur"
                                                                     :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                                                                     class="form-control datepicker text-padding"
                                                                     v-model="employer.workingHoursStart"
                                                                     >
                                                        </flat-picker>
                                                    </base-input>                                    
                                                </div>
                                                <div class="col-sm-1 col-form-label">
                                                  -
                                                </div>
                                                <div class="col-sm-4">
                                                  <base-input addon-left-icon="ni ni-time-alarm">
                                                      <flat-picker slot-scope="{focus, blur}"
                                                                   @on-open="focus"
                                                                   @on-close="blur"
                                                                   :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                                                                   class="form-control datepicker text-padding"
                                                                   v-model="employer.workingHoursEnd"
                                                                   >
                                                      </flat-picker>
                                                  </base-input>  
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Spoken Language:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input>
                                                   <select class="form-control" v-model="employer.spokenLanguage">
                                                     <option value=''>-- Select Spoken Language --</option>
                                                     <template v-for="(data, key) in spokenLanguagesList">
                                                        <option v-bind:key="key" v-bind:value="data.language_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                 </base-input>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Overview:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <!-- <base-input alternative=""
                                                              placeholder="Overview"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.overview"
                                                  /> -->
                                                  <textarea class="form-control" rows="3" placeholder="Overview" v-model="employer.overview"></textarea>
                                                </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Address">
                                              <span slot="title">
                                                  Address
                                              </span>

                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Line 1:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Line 1"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.line1"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Line 2: </div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Line 2"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.line2"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Town:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Town"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.town"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Postal Code:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Postal Code"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.postalCode"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Country:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                   <select class="form-control" v-model="employer.country" v-on:change="getStates()">
                                                     <option value=''>-- Select Country --</option>
                                                     <template v-for="(data, key) in countries">
                                                        <option v-bind:key="key" v-bind:value="data.country_id">{{ data.name }}</option>
                                                    </template>
                                                   </select>
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">State:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                     <!-- <option value=''>-- Select State --</option>
                                                     <template v-for="(data, key) in states">
                                                        <option v-bind:key="key" v-bind:value="data.state_id">{{ data.name }}</option>
                                                    </template> -->
                                                    <base-input alternative=""
                                                              placeholder="State"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.state"
                                                    />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Latitude:<span class="text-danger"></span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Latitude"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.latitude"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Longitude:<span class="text-danger"></span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Longitude"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.longitude"
                                                  />
                                                </div>
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Photos">
                                              <div class="row">
                                                <div class="col-sm-3">Photos: </div>
                                                <div class="col-sm-9">
                                                  <!-- <div class="input-group"> -->
                                                    <div class="custom-file-container" data-upload-id="myUniqueUploadId">
                                                        <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                                        <label class="custom-file-container__custom-file" >
                                                            <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" multiple aria-label="Choose File">
                                                            <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                                            <span class="custom-file-container__custom-file__custom-file-control"></span>
                                                        </label>
                                                        <div class="custom-file-container__image-preview"></div>
                                                    </div>
                                                    <!-- <div class="input-group-prepend">
                                                      <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                                                    </div>
                                                    <div class="custom-file"> -->
                                                      <!-- <input type="file" class="custom-file-input" id="inputGroupFile01"
                                                        aria-describedby="inputGroupFileAddon01" @change="updatePhotos($event)" multiple = "">
                                                      <label class="custom-file-label" for="inputGroupFile01">Choose file</label> -->
  <!--                                                     <label class="custom-file-label" for="inputGroupFile01" v-if="createArticle.fileName != ''">{{createArticle.fileName}}</label> -->
                                                    <!-- </div> -->
                                                  </div>
                                                <!-- </div> -->
                                              </div>
                                          </tab-pane>

                                          <tab-pane title="Banner">
                                             <div class="row">
                                              <div class="col-sm-3">Banner: </div>
                                              <div class="col-sm-9">
                                                <div class="custom-file-container" data-upload-id="bannerUpload">
                                                    <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                                    <label class="custom-file-container__custom-file" >
                                                        <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" aria-label="Choose File" @change="uploadBanner($event)">
                                                        <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                                        <span class="custom-file-container__custom-file__custom-file-control"></span>
                                                    </label>
                                                    <div class="custom-file-container__image-preview"></div>
                                                </div>
                                                <!-- <div class="input-group">
                                                  <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                                                  </div>
                                                  <div class="custom-file">
                                                    <input type="file" class="custom-file-input" id="inputGroupFile01"
                                                      aria-describedby="inputGroupFileAddon01" @change="uploadBanner($event)" multiple = "">
                                                    <label class="custom-file-label" for="inputGroupFile01">Choose file</label> -->
<!--                                                     <label class="custom-file-label" for="inputGroupFile01" v-if="createArticle.fileName != ''">{{createArticle.fileName}}</label> -->
                                                  <!-- </div>
                                                </div> -->
                                              </div>
                                            </div>
                                          </tab-pane>

                                          <tab-pane title="Logo">
                                            <div class="row">
                                              <div class="col-sm-3">Logo: </div>
                                              <div class="col-sm-9">
                                                <div class="custom-file-container" data-upload-id="logoUpload">
                                                    <label><a href="javascript:void(0)" class="custom-file-container__image-clear" title="Clear Image"></a></label>
                                                    <label class="custom-file-container__custom-file" >
                                                        <input type="file" class="custom-file-container__custom-file__custom-file-input" accept="*" aria-label="Choose File" @change="uploadLogo($event)">
                                                        <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                                        <span class="custom-file-container__custom-file__custom-file-control"></span>
                                                    </label>
                                                    <div class="custom-file-container__image-preview"></div>
                                                </div>
                                                <!-- <div class="input-group">
                                                  <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroupFileAddon01">Upload</span>
                                                  </div>
                                                  <div class="custom-file">
                                                    <input type="file" class="custom-file-input" id="inputGroupFile01"
                                                      aria-describedby="inputGroupFileAddon01" @change="uploadLogo($event)" multiple = "">
                                                    <label class="custom-file-label" for="inputGroupFile01">Choose file</label> -->
<!--                                                     <label class="custom-file-label" for="inputGroupFile01" v-if="createArticle.fileName != ''">{{createArticle.fileName}}</label> -->
                                                  <!-- </div>
                                                </div> -->
                                              </div>
                                            </div>
                                          </tab-pane>

                                          <tab-pane title="Credential">
                                              <span slot="title">
                                                  Credential
                                              </span>

                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Login Email:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Login Email"
                                                              input-classes="form-control-alternative"
                                                              type="text"
                                                              v-model="employer.loginEmail"
                                                              :disabled="action == 2"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row" v-if="action == 2">
                                                <div class="col-sm-3 col-form-label">Current Password:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Current Password"
                                                              input-classes="form-control-alternative"
                                                              type="password"
                                                              v-model="employer.currentPassword"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">New Password:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="New Password"
                                                              input-classes="form-control-alternative"
                                                              type="password"
                                                              v-model="employer.password"
                                                  />
                                                </div>
                                              </div>
                                              <div class="form-group row">
                                                <div class="col-sm-3 col-form-label">Confirm Password:<span class="text-danger">*</span></div>
                                                <div class="col-sm-9">
                                                  <base-input alternative=""
                                                              placeholder="Confirm Password"
                                                              input-classes="form-control-alternative"
                                                              type="password"
                                                              v-model="employer.confirmedPassword"
                                                  />
                                                </div>
                                              </div>
                                          </tab-pane>
                                      </card>
                                  </tabs>
                                </div>
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.admin_profile_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" v-if="action == 1" @click="createEmployer()">Create</base-button>
                                    <base-button type="success" class="my-4" v-if="action == 2" @click="updateEmployer(companyId)">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-update-status-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.update_status_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">UPDATE STATUS</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">STATUS: </label> 
                                  <div class="col-sm-9">
                                    <select class="browser-default custom-select" v-model="status">
                                      <option value=''>-- Select Status --</option>
                                      <option value="0">Not Active</option>
                                      <option value="1">Active</option>
                                    </select>
                                  </div>
                                </div>
                            
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.update_status_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="updateStatus()">Update</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="row" id="div-topup-credit-modal">
        <div class="col-md-4">
            <modal :show.sync="modals.topup_credit_modal"
               body-classes="p-0"
               modal-classes="modal-dialog-centered modal-lg">
                <card type="secondary" shadow
                      header-classes="bg-white pb-4"
                      body-classes="px-lg-5 py-lg-5"
                      class="border-0">
                    <template>
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">TOP UP CREDIT: {{ topUpCredit.companyName }}</h3>
                                </div>
                            </div>
                        </div>
                        <form @submit.prevent>
                            <div class="alert alert-danger text-left" v-if="show == true" v-html="message"></div>
                            <div>
                                <div class="form-group row">
                                  <label class="col-sm-3 col-form-label">Package: </label> 
                                  <div class="col-sm-9">
                                    <select class="form-control" v-model="topUpCredit.package">
                                       <option value=''>-- Select Package --</option>
                                       <template v-for="(data, key) in creditPackagesList">
                                          <option v-bind:key="key" v-bind:value="data.id">{{ data.name }}</option>
                                      </template>
                                    </select>
                                  </div>
                                </div>
                            
                                <div class="text-center">
                                    <base-button type="danger" class="my-4" @click="modals.topup_credit_modal = false">Cancel</base-button>
                                    <base-button type="success" class="my-4" @click="topUpCredits()">Create</base-button>
                                </div>
                            </div>
                        </form>
                    </template>
                </card>
            </modal>
        </div>
    </div>

    <div class="card-footer d-flex justify-content-end"
         :class="type === 'dark' ? 'bg-transparent': ''">
      <base-pagination :perPage="10" :total="totalEmployers" :value="pageNumber"></base-pagination>
    </div>

  </div>
</template>
<script>
  import EventBus from './../../event-bus';
  import FileUploadWithPreview from 'file-upload-with-preview';
  import 'file-upload-with-preview/dist/file-upload-with-preview.min.css';
  import flatPicker from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";

  export default {
    name: 'employers-table',
    components: {
      flatPicker
    },
    props: {
      type: {
        type: String
      },
      title: String
    },
    data() {
      return {
        search_text: "",
        uploadedPhotos: '',
        appendToBody: false,
        totalEmployer: 0,
        action: 1,
        show: false,
        message: '',
        status: 0,
        companyId: 0,
        employer: {
          companyName: '',
          companyReg: '',
          industry: '',
          pic: '',
          contactNo: '',
          // emailAddress: '',
          website: '',
          isAnonymous: false,
          dressCode: '',
          companySize: '',
          workingHoursStart: '',
          workingHoursEnd: '',
          spokenLanguage: '',
          overview: '',
          line1: '',
          line2: '',
          town: '',
          postalCode: '',
          state: '',
          country: '',
          latitude: 0.000000,
          longitude: 0.000000,
          loginEmail: '',
          currentPassword: '',
          password: '',
          confirmedPassword: '',
          photo: [],
          original_photo: [],
          banner: '',
          logo: ''
        },
        ipt_country: '',
        topUpCredit: {
          companyName: '',
          companyId: '',
          package: ''
        },
        modals: {
          admin_profile_modal: false,
          update_status_modal: false,
          account_approval_modal: true,
          topup_credit_modal: false
        }
      }
    },
    computed: {
      employers()
      {
        return this.$store.getters.employers;
      },
      countries()
      {
        return this.$store.getters.countries;
      },
      states()
      {
        return this.$store.getters.states;
      },
      dressCodesList()
      {
        return this.$store.getters.dressCodesList;
      },
      industriesList()
      {
        return this.$store.getters.industriesList;
      },
      companySizesList()
      {
        return this.$store.getters.companySizesList;
      },
      spokenLanguagesList()
      {
        return this.$store.getters.spokenLanguagesList;
      },
      creditPackagesList()
      {
        return this.$store.getters.creditPackages;
      },
      pageNumber()
      {
        return parseInt(this.$route.query.page);
      },
      totalEmployers()
      {
        return this.totalEmployer;
      }
    },
    watch: {
      pageNumber() {
        this.getEmployers(this.$route.query.page);
      },

      'modals.admin_profile_modal': function (newVal, oldVal) {
        if(newVal == false)
          location.reload();
      }
    },
    mounted() {
      this.getEmployers(parseInt(this.$route.query.page));
      this.getTotalEmployer();
      this.getCountries();
      this.getDressCodes();
      this.getIndustries();
      this.getCompanySizes();
      this.getSpokenLanguages();
      $('#div-edit-employers-profile').on("hidden.bs.modal", function(e) {
        console.log(e);
      });
      this.uploadedPhotos = new FileUploadWithPreview('myUniqueUploadId');
    },
    methods: {

      getEmployers : function (page_number) {
        this.$store
          .dispatch('fetchEmployers',
          {
            keyword: this.search_text, 
            page : page_number, 
            status : 255
          })
          .then (response => {
            const { data, meta } = response.data;
            this.totalEmployer = meta.total_result;
            this.$router.push({ query: { page: page_number } });
            this.$store.dispatch('updateState', {
                key : 'employers',
                value : data
            });
          });
      },

      getEmployer : function (company_id) {
        this.$store.dispatch('fetchEmployer', {
          id: parseInt(company_id)
        }).then (response => {
          let responseData = response.data;
          this.employer.companyName = responseData.company_name;
          this.employer.companyReg = responseData.registration_number;
          this.employer.industry = responseData.industry;
          this.employer.pic = responseData.pic;
          this.employer.contactNo = responseData.contact_number;
          // this.employer.emailAddress = responseData.email_address;
          this.employer.website = responseData.website;
          this.employer.isAnonymous = responseData.is_anonymous == 1 ? true : false;
          this.employer.dressCode = responseData.dress_code;
          this.employer.companySize = responseData.company_size;
          this.employer.workingHoursStart = responseData.working_hours.split('-')[0];
          this.employer.workingHoursEnd = responseData.working_hours.split('-')[1];
          this.employer.spokenLanguage = responseData.spoken_language;
          this.employer.overview = responseData.overview;
          this.employer.line1 = responseData.line_1;
          this.employer.line2 = responseData.line_2;
          this.employer.town = responseData.city;
          this.employer.postalCode = responseData.postcode;
          this.employer.state = responseData.state;
          this.employer.country = responseData.country;
          this.employer.latitude = responseData.latitude;
          this.employer.longitude = responseData.longitude;
          this.employer.loginEmail = responseData.email_address;
          this.employer.logo = responseData.logo;
        });
      },

      getCountries()
      {
        this.$store.dispatch('fetchCountries').then (response => {
          this.$store.dispatch('updateState', {
              key : 'countries',
              value : response.data
          });
        });
      },

      getStates : function () {
        this.$store.dispatch('fetchStates', {
          country_id : this.employer.country
        }).then (response => {
          this.$store.dispatch('updateState', {
              key : 'states',
              value : response.data
          });
        });
      },

      getDressCodes : function () {
        this.$store.dispatch('fetchDressCodesList').then (response => {
          this.$store.dispatch('updateState', {
              key : 'dressCodesList',
              value : response.data
          });
        });
      },

      getIndustries : function () {
        this.$store.dispatch('fetchIndustriesList').then (response => {
          this.$store.dispatch('updateState', {
              key : 'industriesList',
              value : response.data
          });
        });
      },

      getCompanySizes : function () {
        this.$store.dispatch('fetchCompanySizesList').then (response => {
          this.$store.dispatch('updateState', {
            key : 'companySizesList',
            value : response.data
          });
        });
      },

      getSpokenLanguages : function () {
        this.$store.dispatch('fetchSpokenLanguagesList').then (response => {
          this.$store.dispatch('updateState', {
            key : 'spokenLanguagesList',
            value : response.data
          });
        });
      },

      openModal : function (company_id)
      {
        this.modals.admin_profile_modal = true;
        this.action = 2;
        this.getEmployer(company_id);
      },

      openCreateModal : function ()
      {
        this.show = false;
        this.message = '';
        this.modals.admin_profile_modal = true; 
        this.action = 1;
        this.employer.companyName = '';
        this.employer.companyReg = '';
        this.employer.industry = '';
        this.employer.pic = '';
        this.employer.contactNo = '';
        this.employer.emailAddress = '';
        this.employer.website = '';
        this.employer.isAnonymous = false;
        this.employer.dressCode = '';
        this.employer.companySize = '';
        this.employer.workingHoursStart = '12:00';
        this.employer.workingHoursEnd = '12:00';
        this.employer.spokenLanguage = '';
        this.employer.overview = '';
        this.employer.line1 = '';
        this.employer.line2 = '';
        this.employer.town = '';
        this.employer.postalCode = '';
        this.employer.state = '';
        this.employer.country = '';
        this.employer.latitude = 0.000000;
        this.employer.longitude = 0.000000;
        this.employer.loginEmail = '';
        this.employer.password = '';
        this.employer.confirmedPassword = '';
        this.employer.photo = [];
        this.employer.banner = '';
        this.employer.logo = '';
        this.uploadedPhotos.clearPreviewPanel();
        this.uploadedPhotos.refreshPreviewPanel();
        var bannerUpload = new FileUploadWithPreview('bannerUpload');
        bannerUpload.clearPreviewPanel();
        var logoUpload = new FileUploadWithPreview('logoUpload');
        logoUpload.clearPreviewPanel();
      },

      getTotalEmployer()
      {
        this.$store.dispatch('fetchTotalEmployer', { status: 255 })
            .then((response) => {
              let responseData = response.data;
              this.totalEmployer = parseInt(responseData);
            })
            .catch((e) => {
              console.log(e)
            })
      },

      createEmployer()
      {
        var ins = this.uploadedPhotos.cachedFileArray.length;

        if (ins == 0) {
          this.$store.dispatch('createEmployer', {
             name: this.employer.companyName,
             registration_number: this.employer.companyReg,
             website: this.employer.website,
             working_hour_start: this.employer.workingHoursStart,
             working_hour_end: this.employer.workingHoursEnd,
             company_size: this.employer.companySize,
             industry: this.employer.industry,
             dress_code: this.employer.dressCode,
             spoken_language: this.employer.spokenLanguage,
             company_profile: this.employer.logo,
             company_banner: this.employer.banner,
             company_overview: this.employer.overview,
             anonymous: this.employer.isAnonymous,
             pic_name: this.employer.pic,
             pic_number: this.employer.contactNo,
             company_address_line_1: this.employer.line1,
             company_address_line_2: this.employer.line2,
             company_address_town: this.employer.town,
             company_address_postcode: this.employer.postalCode,
             company_address_state: this.employer.state,
             company_address_country_id: this.employer.country,
             company_address_latitude: this.employer.latitude,
             company_address_longitude: this.employer.longitude,
             company_gallery: [],
             login_email: this.employer.loginEmail,
             current_password: this.employer.currentPassword,
             login_password: this.employer.password,
             confirm_password: this.employer.confirmedPassword
          }).then(response => {
            if (response.data.error == "1000") {
              this.modals.admin_profile_modal = false;
              this.getEmployers(this.$route.query.page);
              EventBus.$emit('updatePendingEmployerCount');
            }  else if (response.data.error == "9999") {
              this.message = response.data.message;
              this.show = true;
            }
          }).catch (error => {
              this.message = 'The login email or password is incorrect.';
              this.show = true;
          });
        } else {
          this.employer.photo = [];
          var promiseAll = [];
          for (var x = 0; x < ins; x++) {
            let formData = new FormData();
            formData.append("file[]", this.uploadedPhotos.cachedFileArray[x]);

            promiseAll.push(this.$store.dispatch('uploadEmployerPhotos', formData));
          }

          Promise.all(promiseAll).then(response => {
            for (var y = 0; y < response.length; y++) {
              if (response[y].status == 200) {
                this.employer.photo.push(response[y].data[0]);
              }
            }

            this.$store.dispatch('createEmployer', {
               name: this.employer.companyName,
               registration_number: this.employer.companyReg,
               website: this.employer.website,
               working_hour_start: this.employer.workingHoursStart,
               working_hour_end: this.employer.workingHoursEnd,
               company_size: this.employer.companySize,
               industry: this.employer.industry,
               dress_code: this.employer.dressCode,
               spoken_language: this.employer.spokenLanguage,
               company_profile: this.employer.logo,
               company_banner: this.employer.banner,
               company_overview: this.employer.overview,
               anonymous: this.employer.isAnonymous,
               pic_name: this.employer.pic,
               pic_number: this.employer.contactNo,
               company_address_line_1: this.employer.line1,
               company_address_line_2: this.employer.line2,
               company_address_town: this.employer.town,
               company_address_postcode: this.employer.postalCode,
               company_address_state: this.employer.state,
               company_address_country_id: this.employer.country,
               company_address_latitude: this.employer.latitude,
               company_address_longitude: this.employer.longitude,
               company_gallery: this.employer.photo,
               login_email: this.employer.loginEmail,
               current_password: this.employer.currentPassword,
               login_password: this.employer.password,
               confirm_password: this.employer.confirmedPassword
            }).then(response => {
              if (response.data.error == "1000") {
                this.modals.admin_profile_modal = false;
                this.getEmployers(this.$route.query.page);
                EventBus.$emit('updatePendingEmployerCount');
              }  else if (response.data.error == "9999") {
                this.message = response.data.message;
                this.show = true;
              }
            }).catch (error => {
                this.message = 'The username or password is incorrect.';
                this.show = true;
            });
          });
        }


        // var ins = this.uploadedPhotos.cachedFileArray.length;

        // if (ins == 0) {
        //   this.$store.dispatch('createEmployer', {
        //      name: this.employer.companyName,
        //      // email_address: this.employer.emailAddress,
        //      registration_number: this.employer.companyReg,
        //      website: this.employer.website,
        //      working_hour_start: this.employer.workingHoursStart,
        //      working_hour_end: this.employer.workingHoursEnd,
        //      company_size: this.employer.companySize,
        //      industry: this.employer.industry,
        //      dress_code: this.employer.dressCode,
        //      spoken_language: this.employer.spokenLanguage,
        //      company_profile: this.employer.logo,
        //      company_banner: this.employer.banner,
        //      company_overview: this.employer.overview,
        //      anonymous: this.employer.isAnonymous,
        //      pic_name: this.employer.pic,
        //      pic_number: this.employer.contactNo,
        //      company_address_line_1: this.employer.line1,
        //      company_address_line_2: this.employer.line2,
        //      company_address_town: this.employer.town,
        //      company_address_postcode: this.employer.postalCode,
        //      company_address_state: this.employer.state,
        //      company_address_country_id: this.employer.country,
        //      company_address_latitude: this.employer.latitude,
        //      company_address_longitude: this.employer.longitude,
        //      company_gallery: [],
        //      login_email: this.employer.loginEmail,
        //      login_password: this.employer.password,
        //      confirm_password: this.employer.confirmedPassword
        //   }).then (response => {
        //     if (response.data.error == "1000") {
        //       this.modals.admin_profile_modal = false;
        //       this.getEmployers(this.$route.query.page);
        //       EventBus.$emit('updatePendingEmployerCount');
        //     }  else if (response.data.error == "9999") {
        //       this.message = response.data.message;
        //       this.show = true;
        //     }
        //   }).catch (error => {
        //       this.message = 'The username or password is incorrect.';
        //       this.show = true;
        //   });
        // } else {
        //   for (var x = 0; x < ins; x++) {
        //     let formData = new FormData();
        //     formData.append("file[]", this.uploadedPhotos.cachedFileArray[x]);

        //     this.$store.dispatch('uploadEmployerPhotos', formData).then (response => {
        //       if (response.status == 200) {
        //         this.employer.photo.push(response.data[0]);
        //         if (x == ins) {
        //           setTimeout( function () {
        //             this.$store.dispatch('createEmployer', {
        //                name: this.employer.companyName,
        //                // email_address: this.employer.emailAddress,
        //                registration_number: this.employer.companyReg,
        //                website: this.employer.website,
        //                working_hour_start: this.employer.workingHoursStart,
        //                working_hour_end: this.employer.workingHoursEnd,
        //                company_size: this.employer.companySize,
        //                industry: this.employer.industry,
        //                dress_code: this.employer.dressCode,
        //                spoken_language: this.employer.spokenLanguage,
        //                company_profile: this.employer.logo,
        //                company_banner: this.employer.banner,
        //                company_overview: this.employer.overview,
        //                anonymous: this.employer.isAnonymous,
        //                pic_name: this.employer.pic,
        //                pic_number: this.employer.contactNo,
        //                company_address_line_1: this.employer.line1,
        //                company_address_line_2: this.employer.line2,
        //                company_address_town: this.employer.town,
        //                company_address_postcode: this.employer.postalCode,
        //                company_address_state: this.employer.state,
        //                company_address_country_id: this.employer.country,
        //                company_address_latitude: this.employer.latitude,
        //                company_address_longitude: this.employer.longitude,
        //                company_gallery: this.employer.photo,
        //                login_email: this.employer.loginEmail,
        //                login_password: this.employer.password,
        //                confirm_password: this.employer.confirmedPassword
        //             }).then (response => {
        //               if (response.data.error == "1000") {
        //                 this.modals.admin_profile_modal = false;
        //                 this.getEmployers(this.$route.query.page);
        //                 EventBus.$emit('updatePendingEmployerCount');
        //               }  else if (response.data.error == "9999") {
        //                 this.message = response.data.message;
        //                 this.show = true;
        //               }
        //             }).catch (error => {
        //                 this.message = 'The username or password is incorrect.';
        //                 this.show = true;
        //             });
        //           }.bind(this), 1000);
        //         }
        //       }
        //     });
        //   }
        // }
      },

      updatePhotos()
      {
        //console.log(this.uploadedPhotos.cachedFileArray);
        // var upload = new FileUploadWithPreview('myUniqueUploadId');
        // upload.clearPreviewPanel();

        // let formData = new FormData();
        // var ins = event.target.files.length;

        // if (ins == 0) {
        //   this.employer.photo = [];
        // } else {
        //   for (var x = 0; x < ins; x++) {
        //     formData.append("file[]", event.target.files[x]);
        //   }

        //   // this.$store.dispatch('uploadEmployerPhotos', formData).then (response => {
        //   //   this.employer.original_photo.push(response.data);
        //   // });
        // }
        // let formData = new FormData();
        // var ins = this.uploadedPhotos.cachedFileArray.length;

        // if (ins == 0) {
        //   this.employer.photo = [];
        // } else {
        //   for (var x = 0; x < ins; x++) {
        //     formData.append("file[]", this.uploadedPhotos.cachedFileArray[x]);
        //   }

        //   this.$store.dispatch('uploadEmployerPhotos', formData).then (response => {
        //     this.employer.photo = response.data;
        //   });
        // }
        
      },

      uploadBanner()
      {
        let formData = new FormData();
        var ins = event.target.files.length;
        for (var x = 0; x < ins; x++) {
            formData.append("file[]", event.target.files[x]);
        }

        this.$store.dispatch('uploadEmployerPhotos', formData).then (response => {
          this.employer.banner = response.data[0];
        });
      },

      uploadLogo()
      {
        let formData = new FormData();
        var ins = event.target.files.length;
        for (var x = 0; x < ins; x++) {
            formData.append("file[]", event.target.files[x]);
        }

        this.$store.dispatch('uploadEmployerPhotos', formData).then (response => {
          this.employer.logo = response.data[0];
        });
      },

      openUpdateStatusModal(company_id, status)
      {
        this.modals.update_status_modal = true;
        this.status = status;
        this.companyId = company_id;
      },

      updateStatus()
      {
        this.$store.dispatch('updateEmployerStatus', {
           id: this.companyId,
           status: this.status
        }).then (response => {
          if (response.data.error == "1000") {
            this.modals.update_status_modal = false;
            this.getEmployers(this.$route.query.page);
            EventBus.$emit('updatePendingEmployerCount');
            EventBus.$emit('updateEmployerCount');
          }
        });
      },

      openUpdateModal(company_id)
      {
        this.show = false;
        this.message = '';
        this.employer.photo = [];
        this.modals.admin_profile_modal = true;
        this.action = 2;
        this.companyId = company_id;

        this.$store.dispatch('fetchEmployer', {
           id: company_id
        }).then (response => {
          let responseData = response.data;

          this.employer.companyName = responseData.company_name;
          this.employer.companyReg = responseData.registration_number;
          this.employer.website = responseData.website;
          this.employer.workingHoursStart = responseData.working_hours.split('-')[0];
          this.employer.workingHoursEnd = responseData.working_hours.split('-')[1];
          this.employer.companySize = responseData.company_size;
          this.employer.industry = responseData.industry;
          this.employer.dressCode = responseData.dress_code;
          this.employer.spokenLanguage = responseData.spoken_language;
          this.employer.logo = responseData.logo_original;
          this.employer.banner = responseData.banner_original;
          this.employer.overview = responseData.overview;
          this.employer.isAnonymous = responseData.is_anonymous == 1 ? true : false;
          this.employer.pic = responseData.pic;
          this.employer.contactNo = responseData.contact_number;
          this.employer.line1 = responseData.line_1;
          this.employer.line2 = responseData.line_2;
          this.employer.town = responseData.city;
          this.employer.postalCode = responseData.postcode;
          this.employer.state = responseData.state;
          this.employer.country = responseData.country;
          this.employer.latitude = responseData.latitude;
          this.employer.longitude = responseData.longitude;
          this.employer.photo = responseData.gallery;
          this.employer.original_photo = responseData.gallery_original;

          this.employer.loginEmail = responseData.email_address;

          
          this.uploadedPhotos.clearPreviewPanel();

          if (responseData.gallery.length === 0) {
            // var upload = new FileUploadWithPreview('myUniqueUploadId');
          } else {
            this.uploadedPhotos.addImagesFromPath(responseData.gallery);
            // console.log(this.uploadedPhotos.cachedFileArray);
          }

          if (responseData.banner != '') {
            var bannerUpload = new FileUploadWithPreview('bannerUpload', {
              presetFiles: [
                responseData.banner
              ]
            });
          } else {
            var bannerUpload = new FileUploadWithPreview('bannerUpload');
          }

          if (responseData.logo != '') {
            var logoUpload = new FileUploadWithPreview('logoUpload', {
              presetFiles: [
                responseData.logo
              ]
            });
          } else {
            var logoUpload = new FileUploadWithPreview('logoUpload');
          }
        });

      },

      updateEmployer()
      {
        var ins = this.uploadedPhotos.cachedFileArray.length;

        if (ins == 0) {
          this.$store.dispatch('updateEmployer', {
             id: this.companyId,
             name: this.employer.companyName,
             registration_number: this.employer.companyReg,
             website: this.employer.website,
             working_hour_start: this.employer.workingHoursStart,
             working_hour_end: this.employer.workingHoursEnd,
             company_size: this.employer.companySize,
             industry: this.employer.industry,
             dress_code: this.employer.dressCode,
             spoken_language: this.employer.spokenLanguage,
             company_profile: this.employer.logo,
             company_banner: this.employer.banner,
             company_overview: this.employer.overview,
             anonymous: this.employer.isAnonymous,
             pic_name: this.employer.pic,
             pic_number: this.employer.contactNo,
             company_address_line_1: this.employer.line1,
             company_address_line_2: this.employer.line2,
             company_address_town: this.employer.town,
             company_address_postcode: this.employer.postalCode,
             company_address_state: this.employer.state,
             company_address_country_id: this.employer.country,
             company_address_latitude: this.employer.latitude,
             company_address_longitude: this.employer.longitude,
             company_gallery: [],
             login_email: this.employer.loginEmail,
             current_password: this.employer.currentPassword,
             login_password: this.employer.password,
             confirm_password: this.employer.confirmedPassword
          }).then(response => {
            console.log(response.data.error);
            if (response.data.error == "1000") {
              this.modals.admin_profile_modal = false;
              this.getEmployers(this.$route.query.page);
            }  else if (response.data.error == "9999") {
              this.message = response.data.message;
              this.show = true;
            }
          });
        } else {
          this.employer.photo = [];
          var promiseAll = [];
          for (var x = 0; x < ins; x++) {
            let formData = new FormData();
            formData.append("file[]", this.uploadedPhotos.cachedFileArray[x]);

            promiseAll.push(this.$store.dispatch('uploadEmployerPhotos', formData));
          }

          Promise.all(promiseAll).then(response => {
            for (var y = 0; y < response.length; y++) {
              if (response[y].status == 200) {
                this.employer.photo.push(response[y].data[0]);
              }
            }

            this.$store.dispatch('updateEmployer', {
               id: this.companyId,
               name: this.employer.companyName,
               registration_number: this.employer.companyReg,
               website: this.employer.website,
               working_hour_start: this.employer.workingHoursStart,
               working_hour_end: this.employer.workingHoursEnd,
               company_size: this.employer.companySize,
               industry: this.employer.industry,
               dress_code: this.employer.dressCode,
               spoken_language: this.employer.spokenLanguage,
               company_profile: this.employer.logo,
               company_banner: this.employer.banner,
               company_overview: this.employer.overview,
               anonymous: this.employer.isAnonymous,
               pic_name: this.employer.pic,
               pic_number: this.employer.contactNo,
               company_address_line_1: this.employer.line1,
               company_address_line_2: this.employer.line2,
               company_address_town: this.employer.town,
               company_address_postcode: this.employer.postalCode,
               company_address_state: this.employer.state,
               company_address_country_id: this.employer.country,
               company_address_latitude: this.employer.latitude,
               company_address_longitude: this.employer.longitude,
               company_gallery: this.employer.photo,
               login_email: this.employer.loginEmail,
               current_password: this.employer.currentPassword,
               login_password: this.employer.password,
               confirm_password: this.employer.confirmedPassword
            }).then(response => {
              console.log(response.data.error);
              if (response.data.error == "1000") {
                this.modals.admin_profile_modal = false;
                this.getEmployers(this.$route.query.page);
              }  else if (response.data.error == "9999") {
                this.message = response.data.message;
                this.show = true;
              }
            });
              
          });
        }
      },

      getCreditPackages()
      {
        this.$store.dispatch('fetchActiveCreditPackages')
            .then((response) => {
                this.$store.dispatch('updateState', {
                    key : 'creditPackages',
                    value : response.data
                });
            }).catch((e) => {
                console.log(e)
            });
      },

      openTopUpCreditModal(company_id, company_name)
      {
        this.message = '';
        this.show = false;
        this.modals.topup_credit_modal = true;
        this.topUpCredit.companyName = company_name;
        this.topUpCredit.companyId = company_id;
        this.getCreditPackages();
      },

      topUpCredits()
      {
        this.$store.dispatch('updateCompanyCredit', {
          company_id: this.topUpCredit.companyId,
          package_id: this.topUpCredit.package
        }).then((response) => {
              if (response.data.error == "1000") {
                this.modals.topup_credit_modal = false;
                this.getEmployers(this.$route.query.page);
              }  else if (response.data.error == "9999") {
                this.message = response.data.message;
                this.show = true;
              }
            }).catch((e) => {
                console.log(e)
            });
      }
    }
  }
</script>
<style>

.col {
  margin-bottom: 15px;
}

.text-padding {
  padding-left: 10px !important;
}

.custom-file-container__custom-file__custom-file-control {
  color: #8898aa;
  border-color: #cad1d7;
}

.custom-file-container__custom-file__custom-file-control__button {
  color: #8898aa;
}
</style>
